<template>
  <div class="news_module">
    <div class="enMainTitle">News</div>
    <div class="news_cup">
      <div class="h_news_img" @click="checkNews(enHomeNews.newsId)">
        <img :src="enHomeNews.picMain" width="490" height="280" alt="">
      </div>
      <div class="h_news_info">
        <p class="h_ennews_title" @click="checkNews(enHomeNews.newsId)">{{enHomeNews.newsTitle}} </p>
        <p class="h_ennews_time">Time : {{enHomeNews.promTime}}</p>
        <p class="h_ennews_text" v-html="enHomeNews.newsSmBody"></p>
        <el-button @click="seeNewsSpace" class="enmore_btn">
          more<i class="el-icon-right  el-icon--right"></i>
        </el-button>
      </div>
      <!-- <el-row>
        <el-col :span="12">
          <div class="h_ennews_pic" @click="checkNews(enHomeNews.newsId)">
            <img :src="enHomeNews.picMain" width="490" height="280" alt="">
          </div>
        </el-col>
        <el-col :span="12">

        </el-col>
      </el-row> -->
    </div>
  </div>
</template>
<script>
import { newsList } from '@/api/enFrontApi/news';
export default {
  data() {
    return {
      enHomeNews: {},
      defaultPath: '../../../static/img/blank.jpg'
    };
  },
  created() {
    this.getHomeNews();
  },
  methods: {
    getHomeNews() {
      this.homeNewsList = [];
      newsList({ pageNo: 1, pageSize: 6 }).then(res => {
        this.enHomeNews = res.data.list[1];
      });
    },
    checkNews(newsId) {
      this.$router.push({
        name: 'iaic2019en/newsInfo',
        params: {
          newsId: newsId
        }
      });
    },
    seeNewsSpace() {
      this.$router.push({ name: 'iaic2019en/news' });
    }
  }
};
</script>
<style lang="stylus" scoped>
.news_module {
  padding-bottom: 20px;
  color: #000;
  width: 100%;
}

.news_cup {
  width: 60%;
  min-width: 996px;
  margin: 0 auto;
  overflow: hidden;

  .h_news_img {
    float: left;
    width: 45%;
    min-width: 490px;
    margin-right: 10px;
  }

  .h_news_info {
    float: left;
    width: 48%;
    min-width: 280px;
  }
}

.h_ennews_pic {
  text-align: center;
}

.h_news_simg:hover {
  cursor: pointer;
}

.h_ennews_title {
  font-size: 16px;
  height: 25px;
  line-height: 25px;
  width: 100%;
  overflow: hidden;
}

.h_ennews_title:hover {
  color: #0e6184;
  cursor: pointer;
}

.h_ennews_time {
  color: #909399;
}

.h_ennews_text {
  overflow: hidden;
  color: #515151;
  line-height: 20px;
  width: 100%;
  height: 125px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6; /* 第10行显示 ... */
  -webkit-box-orient: vertical;
}

.h_ennews_text>>> p {
  background-color: #f3f3f3;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/home/homeNews.vue